module.exports = __webpack_public_path__ + "static/media/Basal_6360.68e7a110.jpg";